'use strict';

module.exports = require('./lib/React');



/*****************
 ** WEBPACK FOOTER
 ** /Users/krasimir/Work/Krasimir/react-cssx/~/react/react.js
 ** module id = 161
 ** module chunks = 0
 **/